(function () {
  var drawer   = document.getElementById('cart-drawer');
  var backdrop = document.getElementById('cart-drawer-backdrop');
  var bodyEl   = document.getElementById('cart-drawer-body');
  var footerEl = document.getElementById('cart-drawer-footer');
  var closeBtn = document.getElementById('cart-drawer-close');
  var countEl  = document.getElementById('cart-count');

  // Shipping estimator (static markup — survives footer re-renders)
  var shipEl       = document.getElementById('cart-drawer-shipping');
  var shipToggle   = document.getElementById('drawer-shipping-toggle');
  var shipPanel    = document.getElementById('drawer-shipping-panel');
  var countrySel   = document.getElementById('drawer-shipping-country');
  var provinceField= document.getElementById('drawer-shipping-province-field');
  var provinceSel  = document.getElementById('drawer-shipping-province');
  var zipEl        = document.getElementById('drawer-shipping-zip');
  var calcBtn      = document.getElementById('drawer-shipping-calc');
  var resultsEl    = document.getElementById('drawer-shipping-results');

  if (!drawer) return;

  // Screen-reader announcements for cart changes (add / qty / remove).
  var liveRegion = document.createElement('div');
  liveRegion.className = 'visually-hidden';
  liveRegion.setAttribute('role', 'status');
  liveRegion.setAttribute('aria-live', 'polite');
  document.body.appendChild(liveRegion);
  function announce(msg) {
    liveRegion.textContent = '';
    requestAnimationFrame(function () { liveRegion.textContent = msg; });
  }

  function money(cents) {
    // Match the Liquid `money_with_currency` format ("$70.00 CAD", "£56.00 GBP"), not Intl's "CA$70.00".
    // narrowSymbol keeps dollar currencies as a bare "$"; the trailing code disambiguates.
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    try {
      return (cents / 100).toLocaleString('en', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }) + ' ' + code;
    } catch (e) {
      return '$' + (cents / 100).toFixed(2) + ' ' + code;
    }
  }

  function resizeImg(url, size) {
    if (!url) return '';
    return url.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Render visible line-item properties (skip Shopify's hidden _-prefixed ones).
  function renderProps(props) {
    if (!props) return '';
    return Object.keys(props).map(function (k) {
      if (k.charAt(0) === '_') return '';
      var v = props[k];
      if (v === null || v === '') return '';
      return '<div class="drawer-item__prop">' + escapeHtml(k) + ': ' + escapeHtml(v) + '</div>';
    }).join('');
  }

  function open() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refresh();
  }

  function close() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Visible message line for cart errors / stock notices (announce() is SR-only).
  var msgEl = document.createElement('p');
  msgEl.className = 'drawer-msg';
  msgEl.hidden = true;
  footerEl.parentNode.insertBefore(msgEl, footerEl);
  function showMsg(text) {
    msgEl.textContent = text;
    msgEl.hidden = !text;
    if (text) announce(text);
  }

  function refresh() {
    bodyEl.innerHTML = '<p class="drawer-loading">Loading…</p>';
    footerEl.innerHTML = '';
    fetch('/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('load failed'); return r.json(); })
      .then(function (cart) { render(cart); updateCount(cart.item_count); })
      .catch(function () {
        bodyEl.innerHTML = '<p class="drawer-loading">Couldn’t load your cart. '
          + '<button type="button" class="drawer-retry">Try again</button></p>';
      });
  }

  function render(cart) {
    showMsg('');
    if (!cart.item_count) {
      bodyEl.innerHTML = '<div class="drawer-empty">'
        + '<p class="drawer-empty__heading">Your cart is empty.</p>'
        + '<p class="drawer-empty__sub">Nothing here yet.</p>'
        + '</div>';
      footerEl.innerHTML = '';
      if (shipEl) shipEl.hidden = true;
      return;
    }

    // Cart contents changed — show the estimator and clear any stale rates.
    if (shipEl) {
      shipEl.hidden = false;
      if (resultsEl) resultsEl.innerHTML = '';
    }

    bodyEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img class="drawer-item__img" src="' + resizeImg(item.image, '120x120') + '" alt="">'
        : '<div class="drawer-item__img-placeholder"></div>';
      return '<div class="drawer-item">'
        + '<a href="' + escapeHtml(item.url) + '">' + img + '</a>'
        + '<div class="drawer-item__info">'
          + '<a class="drawer-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>'
          + (item.product_type ? '<div class="drawer-item__type">' + escapeHtml(item.product_type) + '</div>' : '')
          + renderProps(item.properties)
          + '<div class="drawer-item__qty-row">'
            + '<button class="drawer-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>'
            + '<span class="drawer-qty-count">' + item.quantity + '</span>'
            + '<button class="drawer-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
            + '<button class="drawer-remove" data-key="' + item.key + '" data-qty="0">Remove</button>'
          + '</div>'
        + '</div>'
        + '<div class="drawer-item__price">' + money(item.line_price) + '</div>'
        + '</div>';
    }).join('');

    footerEl.innerHTML = '<div class="drawer-subtotal">'
      + '<span class="drawer-subtotal__label">Subtotal</span>'
      + '<span class="drawer-subtotal__price">' + money(cart.total_price) + '</span>'
      + '</div>'
      + '<a href="/checkout" class="drawer-checkout-btn">Checkout</a>'
      + '<a href="/cart" class="drawer-view-cart">View full cart</a>';
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) {
        // Shopify answers 422 with { description } (e.g. stock limit) — not a cart.
        return r.json().then(
          function (data) { throw new Error((data && data.description) || 'change failed'); },
          function () { throw new Error('change failed'); }
        );
      }
      return r.json();
    })
    .then(function (cart) {
      render(cart);
      updateCount(cart.item_count);
      // /cart/change.js can also clamp to available stock and return 200 —
      // without a note the + button just looks dead.
      var line = (cart.items || []).find(function (i) { return i.key === key; });
      if (qty > 0 && line && line.quantity < qty) {
        showMsg('Only ' + line.quantity + ' available.');
        return;
      }
      var n = cart.item_count;
      announce(n ? 'Cart updated — ' + n + (n === 1 ? ' item.' : ' items.') : 'Your cart is empty.');
    })
    .catch(function (err) {
      showMsg((err && err.message) || 'Couldn’t update your cart. Try again.');
    });
  }

  function updateCount(n) {
    if (!countEl) return;
    countEl.textContent = n > 0 ? '(' + n + ')' : '';
  }

  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!drawer.classList.contains('is-open')) return;
    close();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.drawer-qty-btn, .drawer-remove');
    if (btn) changeQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));

    if (e.target.closest('.drawer-retry')) refresh();

    var cartLink = e.target.closest('#cart-nav-link');
    if (cartLink) { e.preventDefault(); open(); }
  });

  document.addEventListener('cart:open', open);

  // ---- Add to cart (shared by product cards + PDP form) ----
  // `max` is the hard stock ceiling for tracked, deny-policy variants (null = no limit).
  // /cart/add.js happily oversells past stock (only /cart/change.js refuses), so the
  // add path checks the live cart before posting.
  function addToCart(payload, btn, max) {
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var precheck = Promise.resolve();
    if (typeof max === 'number' && isFinite(max)) {
      precheck = fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = cart.items.reduce(function (n, i) {
            return i.id === payload.id ? n + i.quantity : n;
          }, 0);
          if (inCart + payload.quantity > max) {
            var err = new Error('stock limit');
            err.label = 'Already in cart';
            err.description = max === 1
              ? 'This piece is one of a kind — it’s already in your cart.'
              : (inCart >= max
                  ? 'All ' + max + ' available are already in your cart.'
                  : 'Only ' + max + ' available — you already have ' + inCart + ' in your cart.');
            throw err;
          }
        });
    }
    return precheck.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function (r) {
      if (!r.ok) {
        // Shopify's error body carries the human-readable reason (e.g. "All 1 items
        // are in your cart") — keep it so the customer isn't told to retry a dead end.
        return r.json().then(
          function (data) {
            var err = new Error('add failed');
            err.description = data && data.description;
            if (err.description && /in your cart/i.test(err.description)) err.label = 'Already in cart';
            throw err;
          },
          function () { throw new Error('add failed'); }
        );
      }
      return r.json();
    })
    .then(function (line) {
      open();
      announce('Added ' + ((line && line.product_title) || 'item') + ' to your cart.');
      if (btn) {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
      }
    })
    .catch(function (err) {
      announce((err && err.description) || 'Couldn’t add to cart. Please try again.');
      if (btn) {
        btn.textContent = (err && err.label) || 'Couldn’t add';
        btn.title = (err && err.description) || '';
        setTimeout(function () { btn.textContent = orig; btn.title = ''; btn.disabled = false; }, 4000);
      }
    });
  }

  // Product-card quick add (button sits inside the card link — prevent nav)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    var max = btn.dataset.maxQty === undefined ? null : parseInt(btn.dataset.maxQty, 10);
    addToCart({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }, btn, max);
  });

  // PDP form — AJAX instead of full-page reload. The sticky button submits
  // this form via requestSubmit(), so it flows through here too.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pdp-form]');
    if (!form) return;
    e.preventDefault();
    var idEl = form.querySelector('[data-pdp-variant-id]') || form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var id = idEl ? parseInt(idEl.value, 10) : 0;
    if (!id) return;
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    var payload = { id: id, quantity: qty };
    var props = collectProperties(form);
    if (props) payload.properties = props;
    var max = null;
    var maxEl = document.getElementById('pdp-max-qty');
    if (maxEl) {
      try {
        var ceilings = JSON.parse(maxEl.textContent);
        if (Object.prototype.hasOwnProperty.call(ceilings, String(id))) max = ceilings[String(id)];
      } catch (err) {}
    }
    addToCart(payload, form.querySelector('[data-pdp-submit]'), max);
  });

  // Gather line-item properties (e.g. a stamped name) from the PDP form.
  function collectProperties(form) {
    var props = null;
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      var val = (el.value || '').trim();
      if (!val) return;
      props = props || {};
      props[m[1]] = val;
    });
    return props;
  }

  // ---- Shipping estimator ----
  // Mirror the selected country's provinces into the province dropdown.
  // country_option_tags supplies a data-provinces JSON array of [label, value] pairs.
  function populateProvinces() {
    var opt = countrySel.options[countrySel.selectedIndex];
    var provinces = [];
    try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
    if (!provinces.length) {
      provinceField.hidden = true;
      provinceSel.innerHTML = '';
      return;
    }
    provinceField.hidden = false;
    provinceSel.innerHTML = provinces.map(function (p) {
      return '<option value="' + escapeHtml(p[1]) + '">' + escapeHtml(p[0]) + '</option>';
    }).join('');
  }

  function calcShipping() {
    var country  = countrySel.value;
    var province = provinceField.hidden ? '' : provinceSel.value;
    var zip      = (zipEl.value || '').trim();
    resultsEl.innerHTML = '<p class="drawer-shipping__msg">Calculating…</p>';
    var params = 'shipping_address[country]=' + encodeURIComponent(country)
      + '&shipping_address[province]=' + encodeURIComponent(province)
      + '&shipping_address[zip]=' + encodeURIComponent(zip);
    fetch('/cart/shipping_rates.json?' + params)
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          resultsEl.innerHTML = '<p class="drawer-shipping__msg">Enter a valid address to see rates.</p>';
          return;
        }
        var rates = res.data.shipping_rates || [];
        if (!rates.length) {
          resultsEl.innerHTML = '<p class="drawer-shipping__msg">Shipping for this destination is calculated at checkout.</p>';
          return;
        }
        resultsEl.innerHTML = rates.map(function (rate) {
          var cents = Math.round(parseFloat(rate.price) * 100);
          var price = cents === 0 ? 'Free' : money(cents);
          return '<div class="drawer-shipping__rate">'
            + '<span class="drawer-shipping__rate-name">' + escapeHtml(rate.name || rate.presentment_name || '') + '</span>'
            + '<span class="drawer-shipping__rate-price">' + price + '</span>'
            + '</div>';
        }).join('');
      })
      .catch(function () {
        resultsEl.innerHTML = '<p class="drawer-shipping__msg">Couldn’t fetch rates. Try again.</p>';
      });
  }

  if (countrySel) {
    populateProvinces();
    countrySel.addEventListener('change', function () { populateProvinces(); resultsEl.innerHTML = ''; });
    calcBtn.addEventListener('click', calcShipping);
    shipToggle.addEventListener('click', function () {
      var willOpen = shipPanel.hidden;
      shipPanel.hidden = !willOpen;
      shipToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  }

  window.CartDrawer = { open: open, close: close, refresh: refresh };
})();
